// Reusable confirmation dialog for destructive / irreversible actions.
//
// Open it by writing a `confirmAction` object to root state:
//   root.update({
//     confirmAction: {
//       title: 'Delete event?',
//       message: 'This permanently removes "Team standup" from everyone\'s calendar.',
//       confirmText: 'Delete',
//       confirmTheme: 'red',       // theme for the primary button (default: 'red')
//       icon: 'trash',             // header icon (default: 'warning')
//       onConfirm: () => el.call('deleteEventFromSupabase', id)
//     }
//   })
//
// Primary (confirm) button sits on the LEFT per the modal convention. There's
// no Cancel button — the X in the header and backdrop clicks dismiss.
//
// B-101 fixes (2026-04-24):
// - `zIndex: '3000'` so ConfirmModal always stacks ABOVE any originating
//   modal (base Modal is 2000). This is the terminal-confirmation layer;
//   must not be obscured by the action's source modal.
// - `Cancel` button added so both paths are clear. Primary "Confirm" button
//   on the RIGHT with strong visual treatment (filled + bold); Cancel on
//   the LEFT as an outlined secondary. Override `confirmText` with the
//   specific action ("Delete team", "Remove member") so the CTA is
//   self-documenting.
const _action = (root) => root?.confirmAction || null

export const ConfirmModal = {
  extends: 'Modal',
  stateKey: 'confirmAction',
  zIndex: '3000',

  Window: {
    width: 'H',
    maxWidth: '90vw',

    ModalHeader: {
      Hgroup: {
        H: { text: (el, s) => _action(s.root)?.title || 'Are you sure?' },
        P: {
          text: (el, s) =>
            _action(s.root)?.message ||
            'This action cannot be undone. Confirm to proceed.'
        }
      },
      Icons: {
        Indicator: {
          extends: 'IconButton',
          disabled: true,
          cursor: 'default',
          opacity: '.85',
          Icon: { icon: (el, s) => _action(s.root)?.icon || 'warning' }
        }
      }
    },

    ModalFooter: {
      flow: 'x',
      gap: 'Z1',
      align: 'center end',

      CancelBtn: {
        extends: 'Button',
        theme: 'ghost',
        text: (el, s) => _action(s.root)?.cancelText || 'Cancel',
        onClick: (e, el, s) => {
          s.root.update({ confirmAction: null })
        }
      },

      ConfirmBtn: {
        extends: 'Button',
        theme: (el, s) => _action(s.root)?.confirmTheme || 'red',
        fontWeight: '700',
        text: (el, s) => _action(s.root)?.confirmText || 'Confirm',
        onClick: (e, el, s) => {
          const a = _action(s.root)
          s.root.update({ confirmAction: null })
          if (typeof a?.onConfirm === 'function') a.onConfirm()
        }
      }
    }
  }
}
